function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  line-height: 1.5rem;\n  padding-bottom: 0.25rem;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ListItem from '../../molecules/ListItem';
import { defaultTheme } from '../../../utils';
var ListRowWrapper = styled.div(_templateObject());

var ListRow = function ListRow(_ref) {
  var _row$primary, _row$primary2, _row$secondary, _row$secondary2;

  var row = _ref.row,
      containerClass = _ref.containerClass,
      rest = _objectWithoutPropertiesLoose(_ref, ["row", "containerClass"]);

  return /*#__PURE__*/React.createElement(ListRowWrapper, {
    className: containerClass || ''
  }, !!((_row$primary = row === null || row === void 0 ? void 0 : row.primary) !== null && _row$primary !== void 0 ? _row$primary : false) && /*#__PURE__*/React.createElement(ListItem, {
    data: (_row$primary2 = row === null || row === void 0 ? void 0 : row.primary) !== null && _row$primary2 !== void 0 ? _row$primary2 : {},
    variant: "primary"
  }), !!((_row$secondary = row === null || row === void 0 ? void 0 : row.secondary) !== null && _row$secondary !== void 0 ? _row$secondary : false) && /*#__PURE__*/React.createElement(ListItem, {
    data: (_row$secondary2 = row === null || row === void 0 ? void 0 : row.secondary) !== null && _row$secondary2 !== void 0 ? _row$secondary2 : {},
    variant: "secondary"
  }));
};

ListRow.propTypes = process.env.NODE_ENV !== "production" ? {
  row: PropTypes.objectOf(PropTypes.shape({
    primary: PropTypes.object,
    secondary: PropTypes.object
  })).isRequired,
  containerClass: PropTypes.string
} : {};
ListRow.defaultProps = {
  variant: 'default',
  containerClass: '',
  theme: defaultTheme
};
export default ListRow;